module.exports = {
          srcSet: __webpack_public_path__ + "f001dd5f8f92acd19a8e684b170f9026-1168.png"+" 1168w",
          images:[ {path: __webpack_public_path__ + "f001dd5f8f92acd19a8e684b170f9026-1168.png",width: 1168,height: 222}],
          src: __webpack_public_path__ + "f001dd5f8f92acd19a8e684b170f9026-1168.png",
          toString:function(){return __webpack_public_path__ + "f001dd5f8f92acd19a8e684b170f9026-1168.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAACCAYAAABhYU3QAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAXUlEQVR4nAFSAK3/AOR3/f3Rf+b/snrO/q+E0f+8iub/13/D/9x/pP/Viqb+05Zz/+uSMPsAxSPx+bs16v+gT9D+m2TH/6Vm1v+yX6H/wWml/8h62f6/kaP/3YWQ95E2Os0wQvtfAAAAAElFTkSuQmCC",
          width: 1168,
          height: 222
        }